import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import ToggleButton from "../components/ToggleButton";
import styles from "../Dashboard.module.scss";
import MyTasks from "./MyTask";
import { useSelector } from "react-redux";
import StaffTasks from "./StaffTasks";
import { getStorage, setStorage } from "utils";
import constants from "../../../../constants";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import NotAccessible from "../components/NotAccessible";

const AdminTask = ({
  isArchive,
  appliedOfficeFilters,
  appliedStaffFilters,
  selectedOwner,
  handleRedirect,
  isSchedulerOnly,
  showDetail,
  setShowDetail,
  isFromDashboard,
  setEditTaskId,
  setActiveTabForStaff,
  t,
}) => {
  const profile = useSelector((state) => state.userProfile.profile);
  const cachedActiveTab = getStorage(constants.tasks.cache.taskslisting);
  const [activeToggle, setActiveToggle] = useState(
    cachedActiveTab?.activeTab || 1
  );

  const handleToggleChange = (toggle) => {
    setActiveToggle(toggle);
    setShowDetail(false);
    setStorage(constants.tasks.cache.taskslisting, {
      activeTab: toggle,
    });
    if (setActiveTabForStaff) {
      setActiveTabForStaff(toggle);
    }
  };
  const { isStaff, dataAccessValues } = useAccountOwnerCommon();
  
  return (
    <>
      {profile?.isAdmin ? (
        <>
          <ToggleButton
            activeToggle={activeToggle}
            setActiveToggle={handleToggleChange}
            firstText="ASSIGNED TO YOU"
            secondText="ASSIGNED BY YOU"
          />
          {activeToggle === 1 && (
            <div
              className={`${styles.task_card_container} ${
                showDetail ? "m-0" : styles.comment
              }`}
              id="scrollableDivTwo"
            >
              <StaffTasks
                isArchive={isArchive}
                appliedOfficeFilters={appliedOfficeFilters}
                appliedStaffFilters={appliedStaffFilters}
                handleRedirect={handleRedirect}
                isSchedulerOnly={isSchedulerOnly}
                showDetail={showDetail}
                setShowDetail={setShowDetail}
              />
            </div>
          )}
          {activeToggle === 2 && (
            <div
              className={`${styles.task_card_container} ${
                showDetail ? "m-0" : styles.comment
              }`}
              id="scrollableDivTwo"
            >
              {isStaff && !dataAccessValues.isAdmin ? (
                <div className="not-accessible center_property h-100">
                  <NotAccessible Message={t("dashBoard.notAccessible")} />
                </div>
              ) : (
                <MyTasks
                  isArchive={isArchive}
                  appliedOfficeFilters={appliedOfficeFilters}
                  appliedStaffFilters={appliedStaffFilters}
                  selectedOwner={selectedOwner}
                  handleRedirect={handleRedirect}
                  isSchedulerOnly={isSchedulerOnly}
                  showDetail={showDetail}
                  setShowDetail={setShowDetail}
                  isFromDashboard={isFromDashboard}
                  setEditTaskId={setEditTaskId}
                />
              )}
            </div>
          )}
        </>
      ) : (
        <div
          className={`${styles.task_card_container_staff} ${
            showDetail ? "m-0 h-100" : ""
          }`}
          id="scrollableDivTwo"
        >
          <StaffTasks
            isArchive={isArchive}
            appliedOfficeFilters={appliedOfficeFilters}
            appliedStaffFilters={appliedStaffFilters}
            handleRedirect={handleRedirect}
            showDetail={showDetail}
            setShowDetail={setShowDetail}
          />
        </div>
      )}
    </>
  );
};
export default withTranslation()(AdminTask);
